<template>
  <div class="categories-list">
    <div class="tools-list-header">
      <p class="title-row">
        <span class="title-sub">{{ categoryObj.key || categoryObj.name }}</span>
        <span class="list-title">{{ categoryObj.name }}</span>
      </p>
      <p class="description">
        {{ categoryObj.description }}
      </p>
    </div>
    <a-empty v-if="list.length == 0 && !loading" description="暂无工具" />
    <div class="tools-list-content">
      <ToolItem
        v-for="item in list"
        :key="item.id"
        :toolObj="item"
        @toDetail="
          (id, type) => {
            $emit('toDetail', id, type);
          }
        "
        @verify="(url) => { $emit('verify', url) }"
      ></ToolItem>
      <div class="space" v-if="list.length > 5"></div>
      <div class="space" v-if="list.length > 5"></div>
      <div class="space" v-if="list.length > 5"></div>
      <div class="space" v-if="list.length > 5"></div>
    </div>
    <div class="loading-mask">
      <a-spin :spinning="loading" :delay="500" />
    </div>
  </div>
</template>
<script>
import ToolItem from "../cmps/ToolItem";
import { getListById } from "../../../api/tools";
export default {
  name: "categories-list",
  props: {
    categoryObj: {
      type: Object,
    },
  },
  components: {
    ToolItem,
  },
  data() {
    return {
      list: [],
      loading: true,
    };
  },
  created() {
    this.getList(this.categoryObj.id);
  },
  methods: {
    getList(categoryId) {
      try {
        getListById(categoryId).then((res) => {
          if (res && res.code == 200) {
            if (res.data) {
              this.list = res.data;
            }
          }
          this.loading = false;
        });
      } catch (error) {
        this.loading = false;
        this.$error({title: error});
      }
    },
  },
};
</script>
<style scoped>
.categories-list {
  width: 100%;
  padding: 80px 90px;
}
.tools-list-content {
  width: 100%;
  min-height: 170px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.loading-mask {
  width: 100%;
  text-align: center;
}
.space {
  width: 324px;
  height: 0;
  display: inline-block;
  margin: 0 10px;
}
</style>